import { useState } from "react";

const PlansHooks = () => {
  return { value: "", onChangeSearchBar: () => {} };
};

export default PlansHooks;

export const AllPlansHooks = () => {
  return {
    value: "",
    onChangeSearchBar: () => {},
    handleDelete: () => {},
    fetchAllPlans: () => {},
    reloadData: false,
    setReloadData: () => {},
  };
};

export const AddPlansHooks = (setLoading, data) => {
  const [activeTab, setActiveTab] = useState("en");
  const [planInputs, setPlanInputs] = useState({});
  const [planUrlsInputs, setPlanUrlsInputs] = useState({});
  const [UdownloadrlsInputs, setDownloadUrlsInputs] = useState({});
  const [tumbNailUrlsInputs, setTumbNailUrlsInputs] = useState({});
  const [commonPlanUrlsInputs, setCommonUrlsInputs] = useState({});
  const [previewUrlsInputs, setPreviewUrlsInputs] = useState({});
  const [layoutArray, setLayoutArray] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [languagemeta, setLanguagemeta] = useState([]);

  return {
    activeTab,
    activeLanguageDetails: { language_code: "en", language_name: "English" },
    setActiveLanguageDetails: () => {},
    setActiveTab,
    handleInputChange: () => {},
    handleFileInputChange: () => {},
    handleSave: () => {},
    readLanguageData: [],
    planInputs,
    setPlanInputs,
    planErrors: {},
    planUrlsInputs,
    showPlanLibraryModal: false,
    setShowPlanLibraryModal: () => {},
    setPlanUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange: () => {},
    selectedOptions,
    setSelectedOptions,
    deleteRelatedPlan: () => {},
    setSelectedRelatedPlanIndex: () => {},
    handleDropdownChange: () => {},
    setLayoutValues: () => {},
    handlePlanLayoutChange: () => {},
    layoutValues: {},
    initialLayoutValues: {},
    setLayoutInfo: () => {},
    layoutInfo: false,
    handleDateChange: () => {},
    handleAddLayoutToArray: () => {},
    layoutArray,
    setAddedLayout: () => {},
    addedLayout: false,
    handlePlanDateChange: () => {},
    options: [],
    handleDeleteLayoutFromArray: () => {},
    setIsLayoutEdit: () => {},
    isLayoutEdit: false,
    setEditLayoutIndex: () => {},
    setEditTargetLayout: () => {},
    editTargetLayout: "",
    handleLayoutUpdate: () => {},
    updateStateWithTranslation: () => {},
    handleCommonTumbNailInputChange: () => {},
    setCommonUrlsInputs,
    commonPlanUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave: () => {},
    handleSaveLanguage: () => {},
    handleLibraryPlanSelection: () => {},
    handleSendNotification: () => {},
    setLanguagemeta
  };
};
